export const POLL_DATA_HOST = 'https://qcnwhqz64hoatxs4ttdxpml7ze0mxrvg.lambda-url.us-east-1.on.aws'
export const SUBMIT_VOTE_HOST = 'https://a47riucyg3q3jjnn5gic56gtcq0upfxg.lambda-url.us-east-1.on.aws'
export const POPULAR_POLLS_HOST = 'https://iqpemyqp6lwvg7x6ds3osrs6nm0fcjwy.lambda-url.us-east-1.on.aws'
export const IP_INFO_HOST = 'https://awcntp2t5izba44go77lc4evvy0ewfzy.lambda-url.us-east-1.on.aws'

export const NEWSLETTER_HOST = 'https://4c6h4byudhvb77kisfehckmaim0dmswz.lambda-url.us-east-1.on.aws'

export const CAPTCHA_HOST = 'https://fvy6d5uwjmmhjv3bvbtlrcw5xu0ldcjf.lambda-url.us-east-1.on.aws'

export const CREATE_STRIPE_SESSION_HOST = 'https://2hlx5v4iwuaxzbshebnbkeitqi0bhhbk.lambda-url.us-east-1.on.aws'
export const VALIDATE_STRIPE_SESSION_HOST = 'https://2hsykhxggic633voycp33xxwam0ijpvp.lambda-url.us-east-1.on.aws'

export const SEND_SMS_CHALLENGE_HOST = 'https://a53qp2o22d2kljgnjqwux6n5dq0diats.lambda-url.us-east-1.on.aws'
export const VERIFY_SMS_CHALLENGE_HOST = 'https://acnd2kwmzq774ec53s4q6i7sfq0huotn.lambda-url.us-east-1.on.aws'
export const ADD_METADATA_HOST = 'https://3ky5zgrkk5x6tqai2z5viqeury0ymdxg.lambda-url.us-east-1.on.aws'

export const RECENT_VOTES_FILE = 'https://ipvotes.s3.us-east-1.amazonaws.com/recent_votes/all_polls.json'
export const IPVOTES_S3_BUCKET_HOST = 'https://ipvotes.s3.us-east-1.amazonaws.com'

export const AUTH_HOST = 'https://4muvzwnbeezy7vgogyx2z75uaq0lctto.lambda-url.us-east-1.on.aws'

export const DELEGATION_HOST = 'https://kjpewlorf6tyffwlbbcnra2ef40nglvd.lambda-url.us-east-1.on.aws'

export const AGGREGATE_DELEGATIONS_HOST = 'https://vmxpev4fvftful4bor2nby6aja0tbbdt.lambda-url.us-east-1.on.aws'

export const POLL_ATTACHMENT_UPLOAD_HOST = 'https://ej7myauwha2fnaegmr66jappnq0eeedt.lambda-url.us-east-1.on.aws'

export const CAPTCHA_THRESHOLD = 10000

export const VALID_TAGS = ['all', 'global', 'approval rating', 'national', 'other']

export const PUBLIC_PROFILES_HOST = `${IPVOTES_S3_BUCKET_HOST}/public_profiles/`

export const LOG_TRIANGULATION_TEST_HOST = 'https://lzajzm5uwcrbkn3ndakafsfsga0rcqib.lambda-url.us-east-1.on.aws'
